export default __webpack_public_path__ + "static/media/CFD143.bb364c0a.jpg";